<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <!-- Search for small screen-->
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <a class="mr-3 back-icon" @click="$router.push({ path: '/app/service-bookings' })">
                <i class="material-icons">keyboard_backspace</i>
              </a>
            </div>
            <div class="col s10 m6 l6 alignRight">
              <div class="cancel-bloc" v-if="isCancelBooking()">
                <a @click="preCancel()" class="btn">Cancel</a>
              </div>
              <!-- <h5 class="breadcrumbs-title mt-0 mb-0">{{bookingDetail.uid}}</h5> -->
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 35px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100" style="overflow:auto">
                    <div class="row">
                      <div class="col s9 m9 l9">
                        <h4 class="card-title alignLeft">#{{bookingDetail.uid}}</h4>
                      </div>
                      <div class="col s3 m3 l3">
                        <div class="assignee-block">
                          <div class="assignee-title">Assignee</div>
                          <div class="assignee" v-if="bookingDetail.vendor">
                            <b>{{bookingDetail.vendor ? bookingDetail.vendor.first_name : ""}} ({{bookingDetail.vendor ? bookingDetail.vendor.rep_id : ""}})</b>
                          </div>
                          <div class="assignee" v-if="!bookingDetail.vendor">No one</div>
                          <i
                            v-if="!bookingDetail.vendor && isCancelBooking()"
                            @click="openAssignees($event)"
                            class="material-icons a-settings"
                          >settings</i>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col s12 m12 l12">
                        <div class="header-sec">
                          <div class="details">
                            <span
                              v-if="bookingDetail.user"
                              :class="{'p0' : !bookingDetail.user}"
                              class="createdby"
                            >
                              Booked by
                              <b>{{bookingDetail.user ? bookingDetail.user.first_name : ""}}</b>
                            </span>
                            <span class="divider-line">|</span>
                            <span class="classtag">{{bookingDetail.created_at | date('D MMM YYYY')}}</span>
                          </div>
                          <div class="label-status">
                            <span class="prioritytag">{{bookingDetail.service}}</span>
                            <span
                              v-if="bookingDetail.dates"
                              :class="getClassName"
                            >{{bookingDetail.dates ? (bookingDetail.dates.status ? bookingDetail.dates.status.name : "") : ""}}</span>
                            <span :class="getServiceClass">{{bookingDetail.package || "One Time"}}</span>
                          </div>
                        </div>
                        <div class="body-sec">
                          <div class="issue-track-items bg-track-odd1">
                            <div class="desc">
                              <!-- <div class="desc-block">
                                <div class="title-cd">Service Name:</div>
                                <div class="value-cd">{{bookingDetail.service}}</div>
                              </div>-->
                              <div class="desc-block">
                                <div class="title-cd">Booking Cost:</div>
                                <div class="value-cd">Rs.{{bookingDetail.total_cost}}</div>
                              </div>
                              <div class="desc-block">
                                <div class="title-cd">Booking Date & Time:</div>
                                <div
                                  v-if="bookingDetail.dates"
                                  class="value-cd"
                                >{{(bookingDetail.dates.date + ' ' + bookingDetail.dates.time) | date('D MMM YYYY, hh:mm A')}}</div>
                              </div>
                              <div class="desc-block">
                                <div class="title-cd">Booking Address:</div>
                                <div
                                  class="value-cd"
                                  v-if="bookingDetail.address "
                                >{{bookingDetail.address.line1 + (bookingDetail.address.line2 ? ", " + bookingDetail.address.line2 : '') + ", " + bookingDetail.address.city + ", " + bookingDetail.address.state + " - " + bookingDetail.address.postcode}}</div>
                              </div>
                              <div class="desc-block" v-if="bookingDetail.additional_info">
                                <div class="title-cd">Additional Info:</div>
                                <div class="value-cd">{{bookingDetail.additional_info}}</div>
                              </div>
                              <div
                                class="desc-block s-req"
                                v-if="bookingDetail.info && bookingDetail.info.length>0"
                              >
                                <div class="title-cd">Service Requirements:</div>
                                <div
                                  class="ques-list"
                                  v-for="(que,index) in bookingDetail.info"
                                  :key="que.id"
                                >
                                  <div class="ques">
                                    <span>{{index + 1}})</span>
                                    {{que.label}}
                                  </div>
                                  <div class="answr">{{que.value}}</div>
                                </div>
                              </div>
                              <br />
                              <div
                                class="desc-block s-req"
                                v-if="bookingDetail.images && bookingDetail.images.length>0"
                              >
                                <div class="title-cd">Booking Images</div>
                                <div
                                  @click="isImagePreview = img.image"
                                  class="image-list"
                                  v-for="(img) in bookingDetail.images"
                                  :key="img.id"
                                >
                                  <div class="image">
                                    <img :src="img.image" alt />
                                  </div>
                                </div>
                              </div>
                              <!-- <br />
                              <div
                                class="desc-block s-req"
                                v-if="bookingDetail.occurances && bookingDetail.occurances.length>0"
                              >
                                <div class="title-cd">Booking History</div>
                                <div class="list-item">
                                  <ul class="timeline">
                                    <li
                                      class="event"
                                      v-for="(order) in bookingDetail.occurances"
                                      :key="order.id"
                                    >
                                      <h3>{{order.status.name}}</h3>
                                    </li>
                                  </ul>
                                </div>
                              </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="image-popover" v-if="isImagePreview != ''">
      <div class="image-popover-header">
        <div class="img-name">{{isImagePreview.split('/')[isImagePreview.split('/').length - 1]}}</div>
        <div class="img-actions">
          <!-- <a class="img-download" :href="isImagePreview" download>
            <i class="material-icons">cloud_download</i>
          </a> -->
          <div class="img-close" @click="isImagePreview = ''">
            <i class="material-icons">close</i>
          </div>
        </div>
      </div>
      <div class="image-view">
        <img :src="isImagePreview" alt class="img-preview src" />
      </div>
    </div>

    <div class="assignees-list">
      <div class="input-search-box search-input">
        <div class="search-area">
          <i class="material-icons mr-2 search-icon">search</i>
          <input
            type="text"
            placeholder="Search assignees"
            id="assignee_filter"
            class="app-filter assignee_filter"
          />
        </div>
      </div>
      <div class="list-opts">
        <div class="loader" v-if="assigneeLoader">
          <svg
            version="1.1"
            id="L9"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enable-background="new 0 0 0 0"
            xml:space="preserve"
          >
            <path
              fill="#cdefd0"
              d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
            >
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                dur="1s"
                from="0 50 50"
                to="360 50 50"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        </div>
        <div class="assingee-block" v-if="!assigneeLoader">
          <div v-if="assigneeList.length==0" class="assignees-list-items">
            <div class="uname center-align">No vendors found</div>
          </div>
          <div
            class="assignees-list-items"
            @click="selectAssignee(assignee)"
            v-for="(assignee,index) in assigneeList"
            :key="index"
          >
            <!-- <div class="usr-img"><img v-if="assignee.vendor.profile_pic" :src="assignee.vendor.profile_pic" alt=""></div> -->
            <div class="usr-img">{{assignee.vendor.short_name}}</div>
            <div class="uname">{{assignee.vendor.first_name}}</div>
            <div
              class="fullname"
              v-if="assignee.vendor"
            >{{assignee.vendor ? (assignee.vendor.rep_id + ",") : ""}}</div>
            <div class="distance">{{assignee.distance | number}} km away</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoader: true,
      assigneeLoader: false,
      assigneeList: [],
      bookingDetail: {
        dates: {
          status: {
            code: ""
          }
        }
      },
      carousel: {},
      bookingNo: this.$route.params.id,
      isImagePreview:''
    };
  },
  created() {
    this.retrieveBooking();
    this.listAssignees();
    setTimeout(() => {
      $("html")
        .off()
        .on("click", function(e) {
          if (
            !$(e.target).hasClass("a-settings") &&
            !$(e.target).hasClass("assignee_filter")
          ) {
            $(".assignees-list").removeClass("show-assignee");
          }
        });
    }, 500);
  },
  computed: {
    getClassName() {
      if (this.bookingDetail.dates.status) {
        let className = "";
        if (this.bookingDetail.dates.status.name) {
          if (this.bookingDetail.dates.status.name.indexOf("Booked") != -1)
            className = "open";
          else if (
            this.bookingDetail.dates.status.name.indexOf("Started") != -1
          )
            className = "inprogress";
          else if (
            this.bookingDetail.dates.status.name.indexOf("Completed") != -1
          )
            className = "completed";
          else className = "failed";
        }
        return "statustag " + className;
      } else return "statustag";
    },
    getServiceClass() {
      if (this.bookingDetail.package) {
        return "servicetag";
      } else return "servicetag one-time";
    }
  },
  methods: {
    initSlider() {
      setTimeout(() => {
        this.carousel = $(".carousel").carousel({
          indicators: true,
          noWrap: true,
          duration: 150
        });
      }, 500);
    },
    retrieveBooking() {
      this.isLoader = true;
      ajax.get(
        Constants.default.APIURL.RetrieveBooking + this.bookingNo,
        res => {
          this.bookingDetail = res.data;
          this.isLoader = false;
          this.initSlider();
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    openAssignees(ev) {
      var top = $(ev.target).offset().top + 30;
      var left = $(ev.target).offset().left - 400;
      $(".assignees-list").addClass("show-assignee");
      $(".assignees-list").css("top", top + "px");
      $(".assignees-list").css("left", left + "px");
    },
    listAssignees() {
      this.assigneeLoader = true;
      return new Promise(resolve => {
        ajax.get(
          Constants.default.APIURL.RelatedVendors + this.bookingNo,
          res => {
            this.assigneeList = res.data;
            this.assigneeLoader = false;
            resolve(true);
          },
          err => {
            this.assigneeLoader = false;
            resolve(false);
          }
        );
      });
    },
    selectAssignee(assignee) {
      let query = {
        vendor: assignee.vendor.id
      };
      ajax.patch(
        Constants.default.APIURL.AssignVendor + this.bookingNo,
        query,
        res => {
          Vue.toast("Booking has been assigned successfully.");
          this.retrieveBooking();
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    next() {
      this.carousel.carousel("next");
    },
    prev() {
      this.carousel.carousel("prev");
    },
    close() {
      $(".image-slider").removeClass("show-slider");
    },
    open(idx) {
      this.carousel.carousel("set", idx);
      $(".image-slider").addClass("show-slider");
    },
    preCancel() {
      swal({
        title: "Are you sure?",
        text: `This action is irreversible. Do you want to to cancel this booking?`,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: "No",
          delete: "Yes"
        }
      }).then(willDelete => {
        if (willDelete) {
          this.cancelBooking();
        }
      });
    },
    cancelBooking() {
      ajax.put(
        Constants.default.APIURL.CancelBooking + this.bookingNo,
        {},
        res => {
          Vue.toast("Booking has been cancelled successfully.");
          this.retrieveBooking();
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    isCancelBooking() {
      let isCancel =
        this.bookingDetail.dates.status.code == "service_started" ||
        this.bookingDetail.dates.status.code == "service_completed" ||
        this.bookingDetail.dates.status.code == "service_cancelled" ||
        this.bookingDetail.dates.status.code == "payment_failed" ||
        this.bookingDetail.dates.status.code == "admin_service_cancelled";
      return !isCancel;
    }
  }
};
</script>
<style <style lang="scss" scoped>
h5 {
  font-size: 1.5rem;
}
.assignee-block {
  position: relative;
  text-align: left;
  .assignee-title {
    font-weight: 500;
  }
  .assignee {
    font-size: 14px;
    color: rgba(24, 50, 71, 0.6);
  }
  i {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    font-size: 18px;
    perspective-origin: 1000px;
    cursor: pointer;
  }
}

.assignees-list {
  border-radius: 3px;
  border: 1px solid gainsboro;
  padding: 0px;
  max-height: 0;
  transition: 0.3s ease-in-out;
  opacity: 0;
  min-width: 300px;
  z-index: 99999999;
  perspective: 1000px;
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  .list-opts {
    min-height: 100px;
    .loader {
      svg {
        width: 100px;
      }
    }
  }
  .input-search-box {
    padding: 10px;
    position: sticky;
    top: 0;
    background: white;
  }
  .assignees-list-items {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 10px 0px 10px;
    border-bottom: 1px solid #f1eded;
    div {
      margin: 5px;
      padding: 0px;
    }
    .usr-img {
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background: #efe7e7;
    }

    .uname {
      font-weight: 600;
    }
  }
}

.show-assignee {
  max-height: 400px;
  min-width: 400px;
  opacity: 1;
}
.card .card-title {
  font-size: 20px !important;
}
.header-sec {
  text-align: left;
  .details {
    font-size: 14px;
    position: relative;
    .name {
      font-weight: 600;
      padding-right: 10px;
    }
    .divider-line {
      color: gainsboro;
      font-weight: 500;
      font-size: 18px;
      position: absolute;
      bottom: -2px;
    }
    .createdby {
      font-weight: 500;
      padding-right: 10px;
    }
  }
  .label-status {
    display: block;
    margin-bottom: 3px;
    margin-top: 10px;
    .cancel-bloc {
      float: right;
      margin-top: -10px;
    }
  }
  .classtag {
    font-size: 13px;
    margin-left: 15px;
  }
  .prioritytag {
    border: 1px solid gainsboro;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 13px;
  }

  .statustag {
    border: 1px solid #ff5a5a;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 13px;
    margin-left: 15px;
    background: #ff5a5a;
    color: #ffffff;
    font-weight: 500;
    &.inprogress {
      background: #0099ff;
      border-color: #0099ff;
    }
    &.completed {
      background: #3fa93a;
      border-color: #3fa93a;
    }
    &.failed {
      background: #e48b22;
      border-color: #e48b22;
    }
  }
  .servicetag {
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 13px;
    margin-left: 15px;
    color: #212b36;
    font-weight: 500;
    &.one-time {
      border: 1px solid #ffc206;
      background: #fff9c3;
    }
  }
}
.body-sec {
  text-align: left;
  margin-top: 30px;
  .issue-track-items {
    border-radius: 4px;
    margin: 10px 0;
    display: flex;
    .desc {
      width: 100%;
      text-align: left;
      text-transform: capitalize;
      // min-height: 80px;
      .s-req {
        display: block !important;
        .ques {
          padding: 2px 15px;
          font-weight: 500;
          font-size: 14px;
          span {
            padding-right: 8px;
          }
        }

        .answr {
          padding: 0 40px;
          font-weight: 600;
          font-size: 14px;
        }
      }
      .desc-block {
        display: flex;
        .title-cd {
          padding: 5px;
          font-weight: 600;
          font-size: 14px;
        }
        .value-cd {
          padding: 5px;
          font-weight: 500;
          font-size: 14px;
        }
      }
      .image-list {
        display: inline-block;
        cursor: pointer;
        .image {
          padding: 0px;
          margin: 10px;
          width: 100px;
          height: 100px;
          border-radius: 5px;
          img {
            border-radius: 5px;
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
      }
    }
  }
}

.bg-track-odd {
  background: rgb(245, 247, 249) !important;
}

.p0 {
  padding: 0 !important;
  padding-left: 0 !important;
}

//timeline
.timeline {
  border-left: 4px solid #545759;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  color: rgba(0, 0, 0, 1);
  //   margin: 20px auto;
  margin: 0px 10px 20px;
  letter-spacing: 0.5px;
  position: relative;
  line-height: 1.4em;
  font-size: 1.03em;
  padding: 0px 20px 5px;
  list-style: none;
  text-align: left;
  font-weight: 100;
}

.timeline h1,
.timeline h2,
.timeline h3 {
  letter-spacing: 0.5px;
  font-weight: 400;
  font-size: 16px;
}

.timeline .event {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
  padding-bottom: 25px;
  margin-bottom: 50px;
  position: relative;
}

.timeline .event:last-of-type {
  padding-bottom: 0;
  margin-bottom: 0;
  border: none;
}

.timeline .event:before,
.timeline .event:after {
  position: absolute;
  display: block;
  top: 0;
}

.timeline .event:before {
  left: -230.5px;
  color: rgba(0, 0, 0, 0.4);
  content: attr(data-date);
  text-align: right;
  font-weight: 100;
  font-size: 0.9em;
  min-width: 120px;
  text-transform: uppercase;
}

.timeline .event:after {
  box-shadow: 0 0 0 4px #545759;
  left: -29px;
  background: #ffffff;
  border-radius: 50%;
  height: 14px;
  width: 14px;
  content: "";
  top: 3px;
}

.image-popover {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 4%;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  left: 0;

  .image-popover-header {
    position: absolute;
    top: 0;
    width: 100%;
    background: #000000;
    display: flex;
    padding: 0px 25px;
    height: 65px;
    align-items: center;

    .img-name {
      font-size: 16px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ffffff;
      width: 100%;
      text-align: left;
    }

    .img-actions {
      display: inline-flex;
      width: 100%;
      justify-content: flex-end;

      .img-download {
        margin-right: 20px;
        cursor: pointer;

        i.material-icons {
          color: #ffffff;
        }
      }

      .img-close {
        cursor: pointer;

        i.material-icons {
          color: #ffffff;
        }
      }
    }
  }

  .image-view {
    padding-top: 50px;

    img.img-preview {
      width: 654px;
      height: 654px;
      border-radius: 4px;
      object-fit: contain;
    }
  }
}

</style>

